import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

function messageLooksLikeChunkFailure(message: string): boolean {
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Loading chunk')
  );
}

export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  let message = t('errors.unexpected', 'Something went wrong.');
  if (isRouteErrorResponse(error)) {
    message = error.statusText || message;
  } else if (error instanceof Error) {
    message = error.message;
  }

  const isChunkFailure = messageLooksLikeChunkFailure(message);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 py-16 text-center">
      <h1 className="text-xl font-semibold text-foreground">
        {isChunkFailure
          ? t('errors.chunkTitle', 'This page needs a quick refresh')
          : t('errors.unexpectedTitle', 'Unexpected error')}
      </h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {isChunkFailure
          ? t(
              'errors.chunkDescription',
              'We published an update while this tab was open. Reload to load the latest version.',
            )
          : message}
      </p>
      <Button type="button" onClick={() => window.location.reload()}>
        {t('errors.reload', 'Reload page')}
      </Button>
    </div>
  );
}
